<template>
  <div class="cv-number-input bx--form-item">
    <label class="bx--label bx--skeleton" />
    <div class="bx--number bx--skeleton" />
  </div>
</template>

<script>
export default {
  name: 'CvNumberInputSkeleton',
};
</script>
